import React from 'react';


function Contact() {
  return (
    <section id="contact">
      <h2>Contact</h2>
      <ul>
        <li>Håkon Asdøl</li>
        <li><a href="mailto:hasdol98@gmail.com">hasdol98@gmail.com</a></li>
        <li><a href="tel:+4747286648">+4747286648</a></li>
        <li>
          <address>
            Ekkoveien 24, 1341 Slependen
          </address>
        </li>
      </ul>

    </section>
  );
}

export default Contact;